<template>
  <span class="control">
    <a
      class="button is-primary feedback-button"
      @click="clicked_feedback"
      aria-label="Feedback"
    >
      <span class="icon">
        <i class="fas fa-comment"></i>
      </span>
      <span>Feedback</span>
      <FeedbackModal ref="feedbackModal" />
    </a>
  </span>
</template>

<script>
import FeedbackModal from "@/components/FeedbackModal.vue";
export default {
  name: "feedback-button",
  components: { FeedbackModal },
  methods: {
    clicked_feedback: function() {
      this.$refs.feedbackModal.activateModal();
    }
  }
};
</script>

<style scoped>
.feedback-button {
  padding-left: 5px;
  padding-right: 5px;
  color: #6b6b6b;
  background-color: white;
}

.feedback-button:hover {
  color: #363636;
  background-color: white;
}
</style>
